export default "__VITE_ASSET__969a62ae__"